<template>
  <div>
    <view-table ref="viewTable" :limits="limits" :columns-property="columnsProperty" :filter="filter" module="basic"
      url="materials" @reset="resetHandle" @delete="deleteHandle" @select="selectHandle" @addOrEdit="addEditHandle">
      <template slot="otherBtn">
        <el-upload style="float: left" action="" :http-request="importFile" :disabled="importLoading"
          :show-file-list="false">
          <el-button style="margin-left: 10px" v-if="limits.priceAuth" :loading="importLoading" type="primary">
            导入上海出厂价
          </el-button>
        </el-upload>
        <el-upload style="float: left" action="" :http-request="importFile1" :disabled="importLoading"
          :show-file-list="false">
          <el-button style="margin-left: 10px" v-if="limits.priceAuth" :loading="importLoading" type="primary">
            导入江苏出厂价
          </el-button>
        </el-upload>
        <el-button style="margin-left: 10px" v-if="limits.typeAuth" type="primary" :disabled="!selection.length"
          @click="$refs.selectMaterialType.open()">
          绑定类型
        </el-button>
        <el-button style="margin-left: 10px" v-if="limits.onAuth" type="primary" :disabled="!selection.length"
          @click="onHandle">上架</el-button>
        <el-button style="margin-left: 10px" v-if="limits.offAuth" type="primary" :disabled="!selection.length"
          @click="offHandle">下架</el-button>
      </template>
      <template slot="adSearch">
        <div class="vm-search">
          <el-form :inline="true" :model="filter" @keyup.enter.native="loadData(1)">
            <el-form-item label="物料编号">
              <el-input v-model.trim="filter.no" placeholder="请输入物料编号" clearable />
            </el-form-item>
            <el-form-item label="物料名称">
              <el-input v-model.trim="filter.name" placeholder="请输入物料名称" clearable />
            </el-form-item>
            <el-form-item label="规格型号">
              <el-input v-model.trim="filter.specification" placeholder="请输入规格型号" clearable />
            </el-form-item>
            <el-form-item label="物料类型">
              <el-select v-model="materialTypeList" :popper-append-to-body="false" class="biddingStageSty" multiple
                clearable placeholder="请选择" @change="handleSelectMaterialType">
                <el-option v-for="item in materialTypeOptions" :key="item.value" :label="item.name" :value="item.value" />
              </el-select>
            </el-form-item>
            <el-form-item label="物料状态">
              <el-select v-model="filter.statusName" placeholder="请选择物料状态" clearable>
                <el-option label="未上架" value="未上架" />
                <el-option label="已上架" value="已上架" />
              </el-select>
            </el-form-item>
          </el-form>
        </div>
      </template>
      <template slot="actionBtn" slot-scope="scope">
        <el-button v-if="limits.BomAuth" type="primary" @click="$refs.BomPreview.open(scope.row)">BOM</el-button>
        <el-button v-if="limits.priceAuth" type="primary" @click="$refs.materialPrice.open(scope.row)">价格</el-button>
        <el-button v-if="limits.templateAuth" type="primary" @click="$refs.materialTemplate.open(scope.row)">检验模板
        </el-button>
      </template>
    </view-table>
    <big-img :visible="photoVisible" :url="bigImgUrl" @closeClick="closeClick()"/>
    <material-edit ref="materialEdit" @save-success="loadData"/>
    <material-price ref="materialPrice" @save-success="loadData"/>
    <material-type-selector ref="selectMaterialType" @select="selectMaterialType"/>
    <material-bom-preview ref="BomPreview"/>
    <material-template ref="materialTemplate"/>
  </div>
</template>

<script>
import ViewTable from "@/components/ViewTable";
import MaterialEdit from "./MaterialEdit.vue";
import MaterialPrice from "@/views/information/Material/MaterialPrice";
import MaterialTypeSelector from "@/views/information/MaterialTypeName/MaterialTypeSelector";
import MaterialBomPreview from "./MaterialBomPreivew";
import BigImg from "@/components/BigImg";
import MaterialTemplate from "@/views/information/Material/MaterialTemplate";
import loginUtil from "@/util/loginUtil";

export default {
  name: "MaterialList",
  components: {
    ViewTable, MaterialEdit, MaterialPrice,
    MaterialTypeSelector, BigImg,
    MaterialBomPreview,
    MaterialTemplate,
  },
  data() {
    return {
      ids: [],
      selection: [],
      materialTypeList: [],
      materialTypeOptions: [],
      bigImgUrl: "",
      photoVisible: false,
      importLoading: false,
      limits: {
        typeAuth: this.$auth(124),
        addAuth: this.$auth(339),
        editAuth: this.$auth(125),
        delAuth: this.$auth(340),
        priceAuth: this.$auth(127),
        templateAuth: this.$auth(443),
        onAuth: this.$auth(391),
        offAuth: this.$auth(390),
        BomAuth: this.$auth(395),
      },
      filter: {
        no: "",
        name: "",
        specification: "",
        statusName: "",
        materialTypeIds: "",
      },
      columnsProperty: [
        {
          key: "materialNO",
          width: 160,
          render: (h, params) => {
            return h(
              "span",
              {
                style: {
                  color: "#2d8cf0",
                  cursor: "pointer",
                },
                on: {
                  click: () => {
                    this.$refs.materialEdit.open(params.row, true);
                  },
                },
              },
              params.row.materialNO,
            );
          },
        },
        {
          key: "materialName",
          minWidth: 380,
        },
        {
          key: "specification",
          minWidth: 220,
        },
        {
          key: "mrpTypeName",
          width: 90,
          align: "center",
        },
        {
          key: "materialTypeName",
          width: 100,
        },
        {
          key: "statusName",
          width: 90,
          align: "center",
        },
        {
          key: "warehouseLocationName",
          width: 140,
        },
        {
          key: "unitName",
          width: 80,
          align: "center",
        },
        {
          key: "imgPath",
          width: 100,
          align: "center",
          render: (h, params) => {
            if (params.row.imgPath) {
              return h("img", {
                domProps: {
                  src: params.row.imgPath,
                },
                style: {
                  width: "50px",
                  height: "30px",
                  marginTop: "5px",
                },
                on: {
                  click: () => {
                    if (params.row.imgPath) {
                      this.bigImgUrl = params.row.imgPath;
                      this.photoVisible = true;
                    }
                  },
                },
              });
            }
          },
        },
        {
          key: "mlength",
          width: 80,
          align: "center",
        },
        {
          key: "mwidth",
          width: 80,
          align: "center",
        },
        {
          key: "mheight",
          width: 80,
          align: "center",
        },
        {
          key: "mnetWeight",
          width: 80,
          align: "center",
        },
        {
          key: "action",
          align: "center",
          width: 280,
          slot: "action",
          fixed: "right",
        },
      ],
    };
  },
  watch: {
    "filter.materialTypeIds": {
      handler(val) {
        if (val) {
          this.materialTypeList = [];
          this.materialTypeOptions.map(item => {
            val.split(",").forEach((s) => {
              if (parseInt(s) === parseInt(item.value)) {
                this.materialTypeList.push(item.value);
              }
            });
          });
        }
      },
    },
  },
  created() {
    this.getMaterialTypeList();
  },
  methods: {
    loadData(pageNum) {
      this.$refs.viewTable.loadData(pageNum);
    },

    getMaterialTypeList() {
      this.materialTypeOptions = [];
      let temp1 = { "name": "未绑定", "value": 0 };
      this.materialTypeOptions.push(temp1);
      this.$http.get("basic", "materialTypes/getAllList").then((res) => {
        if (res.success) {
          res.data.forEach((item) => {
            let temp = { "name": item.materialTypeName, "value": item.pkid };
            this.materialTypeOptions.push(temp);
          });
        }
      });
    },
    handleSelectMaterialType(value) {
      if (value.length) {
        this.filter.materialTypeIds = value.join(",");
      } else {
        this.filter.materialTypeIds = "";
      }
    },
    resetHandle(filter) {
      this.filter = Object.assign(this.filter, filter);
    },

    selectHandle(selection) {
      this.selection = selection;
      this.selection.forEach((item) => {
        this.ids.push(item.materialID);
      });
    },
    closeClick() {
      this.photoVisible = false;
      this.bigImgUrl = "";
    },
    addEditHandle(row) {
      this.$refs.materialEdit.open(row);
    },

    deleteHandle(row) {
      this.$http.delete("basic", "materials", row.materialID).then((resp) => {
        if (resp.success) {
          this.loadData();
          this.$message.success("删除成功");
        }
      });
    },

    // 绑定类型
    selectMaterialType(row) {
      this.$http.get("basic", `materials/upDateMaterialType/${this.ids}/${row.id}`).then((resp) => {
        if (resp.success) {
          this.loadData();
          this.selection = [];
          this.ids = [];
          this.$message.success("物料类型绑定成功");
        }
      });
    },
    importFile(params) {
      this.importLoading = true;
      let formData = new FormData(); //  用FormData存放上传文件
      formData.append("file", params.file);
      formData.append("Authorization", loginUtil.getToken());
      this.$http
        .post("basic", "materials/import/0", formData)
        .then((res) => {
          if (res.success) {
            this.$message.success("导入成功");
            this.loadData(1);
          }
          this.importLoading = false;
        })
        .catch(() => {
          this.importLoading = false;
        });
    },
    importFile1(params) {
      this.importLoading = true;
      let formData = new FormData(); //  用FormData存放上传文件
      formData.append("file", params.file);
      formData.append("Authorization", loginUtil.getToken());
      this.$http
        .post("basic", "materials/import/1", formData)
        .then((res) => {
          if (res.success) {
            this.$message.success("导入成功");
            this.loadData(1);
          }
          this.importLoading = false;
        })
        .catch(() => {
          this.importLoading = false;
        });
    },
    // 上架
    onHandle() {
      let result = this.selection.every((item) => item.status === 10);
      if (result) {
        this.$http.post("basic", "materials/batchOnShelves", this.ids).then((res) => {
          if (res.success) {
            this.loadData();
            this.selection = [];
            this.ids = [];
            this.$message.success("物料上架成功");
          }
        });
      } else {
        this.$confirm("请选择未上架的物料", "错误", {
          type: "error",
          showCancelButton: false,
        });
      }
    },

    // 下架
    offHandle() {
      let result = this.selection.every((item) => item.status === 50);
      if (result) {
        this.$http.post("basic", "materials/batchDownShelves", this.ids).then((res) => {
          if (res.success) {
            this.loadData();
            this.selection = [];
            this.ids = [];
            this.$message.success("物料下架成功");
          }
        });
      } else {
        this.$confirm("请选择已上架的物料", "错误", {
          type: "error",
          showCancelButton: false,
        });
      }
    },

    // 已上架的物料不能编辑和删除
    otherAuth(row) {
      if (row.status === 50) {
        return {
          editAuth: true,
          delAuth: true,
        };
      } else {
        return {
          editAuth: false,
          delAuth: false,
        };
      }
    },
  },
};
</script>
